import React, { useEffect, useState } from 'react';
import { pageService } from 'services/page.service';

const useAboutUs = () => {
    const [aboutData, setAboutData] = useState({});

    const handleApi = async () => {
        try {
            const response = await pageService.aboutPage()
            setAboutData(response.data.data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        handleApi();
    }, []);

    return { aboutData };
}

export default useAboutUs;